"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextInput = function TextInput(props) {
  var label = props.label || (0, _utils.capitalizeFirstLetter)(props.name),
      placeholder = "".concat(props.t('Enter a value for'), ": ").concat(label),
      hasError = props.errors[props.name],
      error;

  if (hasError) {
    error = props.errors[props.name].map(function (errorMsg) {
      return props.t(errorMsg);
    }).join(', ');
  }

  var keypressHandler = function keypressHandler(e) {};

  if (props.type === 'number') {
    // this is a workaround for firefox. as FF does allow entering non-numerical values, but then treats it as
    // empty value (which does not trigger any onChange event!!) we have to handle it here. So if value is invalid,
    // return false from the keypress handler, which basically simulates the chrome behaviour.
    keypressHandler = function onKeypressHandler(e) {
      var value = e.target.value + e.key;
      if (isNaN(value)) e.preventDefault();
    };
  }

  return /*#__PURE__*/_react.default.createElement("label", {
    className: ['input', hasError ? 'error' : '', props.readOnly ? 'read-only' : ''].join(' ')
  }, label, /*#__PURE__*/_react.default.createElement("span", {
    className: "input__wrapper"
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: props.type,
    name: props.name,
    value: props.value,
    placeholder: placeholder,
    readOnly: props.readOnly,
    onBlur: props.onBlur ? props.onBlur : void 0,
    onChange: props.onChange,
    onKeyPress: keypressHandler,
    disabled: props.disabled
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "input__error"
  }, error));
};

TextInput.defaultProps = {
  type: 'text',
  readOnly: false,
  errors: {},
  disabled: false
};
TextInput.propTypes = {
  t: _propTypes.default.func.isRequired,
  label: _propTypes.default.string.isRequired,
  type: _propTypes.default.string,
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  readOnly: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  errors: _propTypes.default.any,
  disabled: _propTypes.default.bool
};
var _default = TextInput;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-inputs/text.js
// module id = 508
// module chunks = 0